import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import mainAxios from "../../../services/mainAxios";
import { useHistory } from 'react-router-dom';
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";


export const KeycloackContext = React.createContext(null);

export const useKeycloackStore = () => React.useContext(KeycloackContext);

let store;
let processedCode = null;

export const getStore = () => ({ ...store });


export const unlinkProvider = ({provider, record_user,userId,onSuccess}) => {
        return mainAxios.post("/api/keycloak/unlink-idp", {
            provider,
            record_user,
            userId
        }).then(res => {
          if(res?.data?.status){
            if(onSuccess) onSuccess(res?.data?.message)
          }
    })
    .catch(()=>{
    })
  }

export const KeyCloackProvider = ({ children }) => {
  const location = useLocation();
  const history = useHistory()
  const [loading,setLoading]=useState(false)
  const linkingRef = useRef(false)
    const { t } = useTranslation('translations');

    const linkProvider = ({provider, verifier,userId,authorizationCode,pathname}) => {
      if(loading || linkingRef.current) return
      linkingRef.current = true
      setLoading(true)
        mainAxios.post("/api/keycloak/link-idp", {
            provider,
            authorizationCode, 
            userId,
            verifier
        }).then(res => {
          setLoading(false)
          linkingRef.current = false
          if(res?.data?.status){
            history.push({
              pathname: pathname,
              search: '?refresh=true',
              });
              toast.success(t("users.userLinkedSuccessfully", { provider:provider.toLowerCase() }), {
                containerId: "all_toast",
              });

          }
    })
      .catch(()=>{
        setLoading(false)
        linkingRef.current = false
      })
  }

    useEffect(() => {
      const queryString = location.search;
      const urlParams = new URLSearchParams(queryString);

      const authorizationCode = urlParams.get('code');
      const stateRaw = urlParams.get("state");
      if (authorizationCode && stateRaw && authorizationCode !== processedCode) {
        const state = JSON.parse(decodeURIComponent(stateRaw));
        const {userId,action,pathname,provider,verifier}=state
        if(userId && action=="link"){
          processedCode = authorizationCode;
          history.push({
            pathname: pathname,
          });
          linkProvider({provider,userId,authorizationCode,pathname,verifier})
        }
      }
    }, [location.search]); 

    const store={
      loading,
      setLoading
    }

  return <KeycloackContext.Provider value={store}>{children}</KeycloackContext.Provider>;
};
